<div class="sidebar-container">
  <!-- Close Button -->
  <div class="dis-flex flex-r margin-top-5">
    <button class="close-button" (click)="closeSidebar()">
      <ng-icon name="hugeMultiplicationSign"></ng-icon>
    </button>
  </div>

  <!-- home sidebar -->
  <ng-container *ngIf="isHomeSidebar">

     <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Year" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeYear"
        placeholder="Select Year"
        [(ngModel)]="sidebarService.selectedHomeYear"
        filterPlaceholder="Search"
        [showClear]="false"
        optionLabel="value"
        (onChange)="onHomeYearChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"
      >
      </p-dropdown>
    </div>
    <div class="item-container m-b-15" *ngIf="this.selectedRole != 'affiliate'">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Cycle
      </p>
      <p-dropdown
        [options]="quarter"
        optionLabel="quarterVal"
        optionValue="quarter"
        (onChange)="onQuarterFilterChange($event)"
        placeholder="Select Cycle"
        [(ngModel)]="sidebarService.selectedHomeQuarter"
        [overlayOptions]="helper.getOverlayOptions()"

      />
    </div>
    <div>
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Business Theme" }}
      </p>
      <p-dropdown
        [options]="businessThemeLists"
        optionLabel="value"
        optionValue="theme_id"
        (onChange)="onThemeFilterChange($event.value)"
        placeholder="Select an Option"
        [(ngModel)]="sidebarService.selectedHomeThemeId"
        (onFilter)="onWPThemeSearch($event)"
        filter="true"
        filterPlaceholder="Search"
        [showClear]="true"
        [overlayOptions]="helper.getOverlayOptions()"

      />
    </div>
  </ng-container>

  <!-- workpackage sidebar -->
  <ng-container *ngIf="isWPSidebar">
    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Business Theme Based On Year" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeYear"
        placeholder="Select Year"
        [(ngModel)]="sidebarService.selectedWPYear"
        filterPlaceholder="Search"
        [showClear]="false"
        optionLabel="value"
        (onChange)="onWPYearChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"
      >
      </p-dropdown>
    </div>
    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Business Theme" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="businessThemeLists"
        placeholder="Select an Option"
        filter="true"
        [(ngModel)]="sidebarService.selectedBusinessTheme"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="value"
        (onFilter)="onWPThemeSearch($event)"
        (onChange)="onThemeChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Team Member" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="teamMembersLists"
        placeholder="Select an option"
        filter="true"
        (onFilter)="onWPTeamSearch($event)"
        [(ngModel)]="sidebarService.selectedMember"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="name"
        (onChange)="onTeamChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "User Type" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="userTypeLists"
        [(ngModel)]="sidebarService.selectedUserType"
        placeholder="Select an option"
        [showClear]="true"
        optionLabel="value"
        (onChange)="onUserTypeChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Status" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="statusLists"
        placeholder="Select an option"
        [showClear]="true"
        [(ngModel)]="sidebarService.selectedStatus"
        optionLabel="value"
        (onChange)="onStatusChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Brand" }}
      </p>
      <p-dropdown
        id="dropdown"
        name="brand_id"
        [options]="brandLists"
        placeholder="Select an option"
        filter="true"
        filterPlaceholder="Search"
        [(ngModel)]="sidebarService.selectedBrand"
        [showClear]="true"
        (onClear)="onBrandClear()"
        optionLabel="brand"
        (onChange)="onBrandChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Therapeutic Area" }}
      </p>
      <p-dropdown
        id="dropdown"
        name="therapeutic_area_id"
        [options]="therapeuticAreaLists"
        placeholder="Select an option"
        filter="true"
        filterPlaceholder="Search"
        [(ngModel)]="sidebarService.selectedTherapeuticArea"
        [showClear]="true"
        optionLabel="area"
        (onChange)="onTherapeuticAreaChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Indication" }}
      </p>
      <p-dropdown
        id="dropdown"
        name="indication_id"
        [options]="IndicationLists"
        placeholder="Select an option"
        filter="true"
        [(ngModel)]="sidebarService.selectedIndication"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="indication"
        (onChange)="onIndicationChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>
  </ng-container>

  <!-- workpackage Dashboard sidebar -->
  <ng-container *ngIf="isWpDashboard">
    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Team Member" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="teamMembersLists"
        placeholder="Select an option"
        filter="true"
        (onFilter)="onWPTeamSearch($event)"
        [(ngModel)]="sidebarService.selectedWPDashboardMember"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="name"
        (onChange)="onWPDashboardTeamChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>
  </ng-container>

  <!-- mytask sidebar -->
  <ng-container *ngIf="isTask">
    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Year" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeYear"
        placeholder="Select Year"
        [(ngModel)]="sidebarService.selectedTaskYear"
        filterPlaceholder="Search"
        [showClear]="false"
        optionLabel="value"
        (onChange)="onTaskYearChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Cycle
      </p>
      <p-dropdown
        id="dropdown"
        name="quarter"
        [options]="quarter"
        placeholder="Select Cycle"
        [(ngModel)]="sidebarService.selectedTaskQuarter"
        filterPlaceholder="Search"
        optionValue="quarter"
        optionLabel="quarterVal"
        (onChange)="onQuarterChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Business Theme" }}
      </p>
      <p-dropdown
        id="dropdown"
        name="theme_id"
        [options]="businessThemeLists"
        placeholder="Select an Option"
        filter="true"
        [(ngModel)]="sidebarService.selectedTaskThemeId"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="value"
        (onFilter)="onWPThemeSearch($event)"
        (onChange)="onTaskThemeChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Types of work" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="TypesOfWork"
        placeholder="Select an option"
        [(ngModel)]="sidebarService.selectedTaskType"
        [showClear]="true"
        optionLabel="label"
        (onChange)="onTypeWorkChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "STO Status" }}
      </p>
      <p-dropdown
        id="dropdown"
        name="quarter_id"
        [options]="taskLists"
        [(ngModel)]="sidebarService.selectedTaskStatus"
        placeholder="Select an option"
        [showClear]="true"
        optionLabel="value"
        (onChange)="quarterOutcomesChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>
   

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Show Untouched MTO
      </p>
      <div class="flex flex-wrap gap-3">
        <div class="flex align-items-center">
          <p-radioButton
            name="untouched-annual-outcome"
            value="yes"
            [(ngModel)]="sidebarService.selectedTaskUntouched"
            inputId="yes"
            (onClick)="onUntouchedQuarterOutcomeChange($event)"
          ></p-radioButton>
          <label for="yes" class="b2 text-80 ml-2">Yes</label>
        </div>
        <div class="flex align-items-center ml-3">
          <p-radioButton
            name="untouched-annual-outcome"
            value="no"
            [(ngModel)]="sidebarService.selectedTaskUntouched"
            inputId="no"
            (onClick)="onUntouchedQuarterOutcomeChange($event)"
          ></p-radioButton>
          <label for="no" class="b2 text-80 ml-2">No</label>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- dependencies sidebar -->
  <ng-container *ngIf="isDependecies">
    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Year" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeYear"
        placeholder="Select Year"
        [(ngModel)]="sidebarService.selectedDependenciesYear"
        filterPlaceholder="Search"
        [showClear]="false"
        optionLabel="value"
        (onChange)="onDependenciesYearChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Cycle
      </p>
      <p-dropdown
        [options]="quarter"
        [(ngModel)]="sidebarService.selectedDependenciesQuarter"
        optionLabel="quarterVal"
        optionValue="quarter"
        (onChange)="onDependeciesQuarterChange($event)"
        placeholder="Select Cycle"
        [overlayOptions]="helper.getOverlayOptions()"

      />
    </div>
  </ng-container>

  <!-- outcome sidebar -->
  <ng-container *ngIf="isOutcome">

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Year" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeYear"
        placeholder="Select Year"
        [(ngModel)]="sidebarService.selectedOutcomeYear"
        filterPlaceholder="Search"
        [showClear]="false"
        optionLabel="value"
        (onChange)="onOutcomeYearChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Business Theme" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="businessThemeLists"
        placeholder="Select an Option"
        filter="true"
        [(ngModel)]="sidebarService.selectedOutcomeBusinessTheme"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="value"
        (onFilter)="onWPThemeSearch($event)"
        (onChange)="onOutcomeTaskThemeChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Show Affiliate MTO
      </p>
      <div class="flex flex-wrap gap-3">
        <div class="flex align-items-center">
          <p-radioButton
            name="affiliate-outcome"
            value="yes"
            [(ngModel)]="sidebarService.is_affiliate"
            inputId="yes"
            (onClick)="onAffiliateOutcomeChange($event)"
          ></p-radioButton>
          <label for="yes" class="b2 text-80 ml-2">Yes</label>
        </div>
        <div class="flex align-items-center ml-3">
          <p-radioButton
            name="affiliate-outcome"
            value="no"
            [(ngModel)]="sidebarService.is_affiliate"
            inputId="no"
            (onClick)="onAffiliateOutcomeChange($event)"
          ></p-radioButton>
          <label for="no" class="b2 text-80 ml-2">No</label>
        </div>
      </div>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Groups" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeListParentGroup"
        placeholder="Select an option"
        filter="true"
        [(ngModel)]="sidebarService.selectedOutcomeGroup"
        filterPlaceholder="Search"
        [showClear]="true"
        display="chip"
        (onClear)="clearOutcomeGroup()"
        optionLabel="name"
        (onFilter)="onParentStandaloneGroupSearch($event)"
        (onChange)="onOutcomeGroups($event)"
        [overlayOptions]="helper.getOverlayOptions()"
      >
      </p-dropdown>
    </div>
    <div
      class="item-container m-b-15"
      *ngIf="sidebarService.selectedOutcomeGroup && this.sidebarService.selectedOutcomeGroup?.link== 'parent'" 
    >
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Sub Groups" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="selectOutcomeSubGroupsData"
        placeholder="Select an option"
        filter="true"
        (onClear)="clearOutcomeSubGroup()"
        [(ngModel)]="sidebarService.selectedOutcomeSubgroup"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="name"
        (onFilter)="onsubGroupSearch($event)"
        (onChange)="onOutcomeSubgroups($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15" *ngIf="sidebarService.selectedOutcomeGroup">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Team Member" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeTeamMembers"
        placeholder="Select an option"
        filter="true"
        (onFilter)="onOutcoMemberSearch($event)"
        [(ngModel)]="sidebarService.selectedOutcomeMembers"
        filterPlaceholder="Search"
        [showClear]="true"
        (onClear)="clearSearch()"
        optionLabel="name"
        (onChange)="onOutcomeTeamChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "MTO status" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="taskLists"
        placeholder="Select an option"
        [(ngModel)]="sidebarService.selectedOutcomeAnnualOutcomeStatus"
        [showClear]="true"
        optionLabel="value"
        (onChange)="onOutcomeAnnual($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Show Untouched MTO
      </p>
      <div class="flex flex-wrap gap-3">
        <div class="flex align-items-center">
          <p-radioButton
            name="untouched-annual-outcome"
            value="yes"
            [(ngModel)]="sidebarService.selectedOutcomeUntouched"
            inputId="yes"
            (onClick)="onOutcomeUntouchedQuarterOutcomeChange($event)"
          ></p-radioButton>
          <label for="yes" class="b2 text-80 ml-2">Yes</label>
        </div>
        <div class="flex align-items-center ml-3">
          <p-radioButton
            name="untouched-annual-outcome"
            value="no"
            [(ngModel)]="sidebarService.selectedOutcomeUntouched"
            inputId="no"
            (onClick)="onOutcomeUntouchedQuarterOutcomeChange($event)"
          ></p-radioButton>
          <label for="no" class="b2 text-80 ml-2">No</label>
        </div>
      </div>
    </div>

  </ng-container>

  <!-- dashboard sidebar -->
  <ng-container *ngIf="isDashboard">
    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        {{ "Year" }}
      </p>
      <p-dropdown
        id="dropdown"
        [options]="outcomeYear"
        placeholder="Select Year"
        [(ngModel)]="sidebarService.selectedProgressDashboardYear"
        filterPlaceholder="Search"
        [showClear]="false"
        optionLabel="value"
        (onChange)="onProgressDashboardYearChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"
      >
      </p-dropdown>
    </div>


    <div class="item-container m-b-15" *ngIf="type =='quarterly'">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Cycle
      </p>
      <p-dropdown
        [options]="quarter"
        optionLabel="quarterVal"
        optionValue="quarter"
        (onChange)="onProgressDashboardQuarterFilterChange($event.value)"
        placeholder="Select Cycle"
        [(ngModel)]="selectedQuater"
        [overlayOptions]="helper.getOverlayOptions()"

      />
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Business Theme
      </p>
      <p-dropdown
        id="dropdown"
        [options]="businessThemeLists"
        placeholder="Select an Option"
        filter="true"
        [(ngModel)]="sidebarService.selectedProgressDashboardBusinessTheme"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="value"
        (onFilter)="onWPThemeSearch($event)"
        (onChange)="onProgressDashboardThemeChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Groups
      </p>
      <p-dropdown
        id="dropdown"
        [options]="progressDashboardListParentGroup"
        placeholder="Select an option"
        [(ngModel)]="sidebarService.selectedProgressDashboardGroup"
        filterPlaceholder="Search"
        optionLabel="name"
        filter="true"
        (onClear)="onClearProgressDashGroup()"
        [showClear]="true"
        (onFilter)="onProgressDashboardGroupSearch($event)"
        (onChange)="onOutcomeGroupsP($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>
    <div
      class="item-container m-b-15"
      *ngIf="sidebarService.dashboardData.outcome_groups && this.sidebarService.selectedProgressDashboardGroup?.link == 'parent'"
    >
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Sub Groups
      </p>
      <p-dropdown
        id="dropdown"
        [options]="selectProgressDashSubGroupsData"
        placeholder="Select an option"
        filter="true"
        [(ngModel)]="sidebarService.selectedProgressDashboardSubgroup"
        filterPlaceholder="Search"
        (onClear)="clearSubGroup()"
        [showClear]="true"
        optionLabel="name"  
        (onFilter)="onsubGroupSearch($event)"
        (onChange)="onProgressDashboardSubgroups($event)"
        [overlayOptions]="helper.getOverlayOptions()"
      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15"  *ngIf="sidebarService.dashboardData.outcome_groups">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Team Member
      </p>
      <p-dropdown
        id="dropdown"
        [options]="progressDashTeamMembers"
        placeholder="Select an option"
        filter="true"
        (onFilter)="onOutcoMemberSearch($event)"
        [(ngModel)]="sidebarService.selectedProgressDashboardMembers"
        filterPlaceholder="Search"
        [showClear]="true"
        optionLabel="name"
        (onClear)="onClearTeamProgressDash()"
        (onChange)="onProgressDashboardTeamChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>

    <div class="item-container m-b-15">
      <p class="item-title text-left m-b-0 b2 font-medium text-80">
        Status
      </p>
      <p-dropdown
        id="dropdown"
        [options]="taskLists"
        placeholder="Select an option"
        (onClear)="onProgressDashboardStatusClear()"
        [(ngModel)]="sidebarService.selectedProgressDashboardoutcome_status"
        [showClear]="true"
        optionLabel="value"
        (onChange)="onProgressDashboardAnnual($event)"
        [overlayOptions]="helper.getOverlayOptions()"

      >
      </p-dropdown>
    </div>
  </ng-container>
</div>
